// The create function is called after the component is created
// and has been added to the DOM. It only runs in the browser
exports.create = function(model, dom) {
	//avoid spam by not having the full email address listed anywhere, not even in the JS
	var address = 'feedback', domain = 'musicaltheatersongs.com';
	model.set('contactEmail', address + '@' + domain);
}